/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { ColorAlias, getThemeColorFromAlias, theme } from "../../theme";

interface LogoProps {
  onClick?: () => void;
  color?: ColorAlias;
}

const SwissreLogo: FC<LogoProps> = ({ onClick, color }) => {
  const logoColor = color
    ? getThemeColorFromAlias(color, theme.colors)
    : getThemeColorFromAlias("Green", theme.colors);
  return (
    <span onClick={onClick}>
      <svg
        height="25"
        viewBox="0 0 258 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.3608 21.4207H15.1401V15.0678H45.3608V21.4207ZM45.064 45.7635H38.3549V26.1705H45.064V45.7635ZM33.605 45.7635H26.8959V26.1705H33.605V45.7635ZM22.146 45.7635H15.4369V26.1705H22.146V45.7635ZM30.2208 0.224609C13.537 0.224609 0 13.7616 0 30.386C0 47.0697 13.537 60.6068 30.2208 60.6068C46.9045 60.6068 60.4415 47.0697 60.4415 30.386C60.4415 13.7616 46.9045 0.224609 30.2208 0.224609Z"
          fill={logoColor}
        />
        <path
          d="M103.19 23.677H96.8962C96.8368 20.7084 94.64 18.9865 91.7307 18.9865C89.2371 18.9865 86.2684 19.9365 86.2684 22.9052C86.2684 29.733 104.08 25.2207 104.08 36.3828C104.08 43.27 98.143 46.3574 91.9088 46.3574C84.7841 46.3574 78.8468 43.8638 78.9062 36.0265H85.6153C85.6153 39.4108 87.4559 41.7263 91.0776 41.7263C93.7494 41.7263 97.2524 40.7764 97.2524 37.5702C97.2524 30.4455 79.7374 35.2547 79.7374 23.7958C79.7374 16.9679 86.0309 14.3555 91.9088 14.3555C98.0836 14.3555 102.774 17.3835 103.19 23.677Z"
          fill={logoColor}
        />
        <path
          d="M129.195 45.8222L126.108 35.6101C125.455 33.354 125.039 31.0978 124.564 28.901C124.208 30.5041 123.97 32.1665 123.495 33.7102L123.02 35.432L120.17 45.8222H112.63L105.624 24.3887H112.808L115.777 35.6101L116.192 37.1538L116.549 38.6381C116.667 39.5287 116.846 40.4193 116.964 41.3099C117.321 38.7569 117.914 36.2632 118.567 33.8289L121.239 24.3887H128.601L131.392 34.2446C132.045 36.5601 132.52 38.8756 132.876 41.2505L133.054 40.0037C133.351 37.985 133.886 35.9664 134.479 33.9477L137.151 24.3887H144.038L136.676 45.8222H129.195Z"
          fill={logoColor}
        />
        <path
          d="M147.245 45.8222V24.3887H153.657V45.8222H147.245Z"
          fill={logoColor}
        />
        <path
          d="M147.007 20.3525V15.0684H153.835V20.3525H147.007Z"
          fill={logoColor}
        />
        <path
          d="M175.268 30.0291H169.569C169.45 28.4854 168.025 27.6542 166.481 27.6542C165.116 27.6542 163.156 28.0698 163.216 29.8509C163.275 31.2165 164.759 31.6321 165.888 31.8696L168.322 32.4633C172.062 33.2946 176.337 34.8383 176.337 39.3506C176.337 44.8129 170.756 46.416 166.303 46.416C161.91 46.416 157.516 44.4566 157.219 39.7068H163.156C163.335 41.6068 164.878 42.5567 166.719 42.5567C168.381 42.5567 170.459 41.9036 170.459 39.8849C170.459 35.7882 157.694 38.6975 157.694 30.4447C157.694 25.398 162.741 23.7949 166.956 23.7949C170.816 23.7949 174.734 25.3386 175.328 29.5541L175.268 30.0291Z"
          fill={logoColor}
        />
        <path
          d="M196.287 30.0291H190.587C190.468 28.4854 189.043 27.6542 187.499 27.6542C186.134 27.6542 184.174 28.0698 184.234 29.8509C184.293 31.2165 185.778 31.6321 186.906 31.8696L189.34 32.4633C193.08 33.2946 197.355 34.8383 197.355 39.3506C197.355 44.8129 191.774 46.416 187.321 46.416C182.928 46.416 178.534 44.4566 178.237 39.7068H184.174C184.353 41.6068 185.896 42.5567 187.737 42.5567C189.399 42.5567 191.477 41.9036 191.477 39.8849C191.477 35.7882 178.712 38.6975 178.712 30.4447C178.712 25.398 183.759 23.7949 187.974 23.7949C191.834 23.7949 195.752 25.3386 196.346 29.5541L196.287 30.0291Z"
          fill={logoColor}
        />
        <path
          d="M220.986 28.3085H216.236V19.8776H221.045C223.776 19.8776 226.032 21.0056 226.032 24.0337C226.032 27.121 223.776 28.3085 220.986 28.3085ZM226.329 30.5647C230.129 29.496 232.979 27.1804 232.979 22.9649C232.979 17.0277 227.457 15.0684 222.351 15.0684H209.646V45.8235H216.236V33.4146H221.401C227.339 33.4146 225.914 41.608 226.864 45.8235H234.048C230.782 40.0049 234.76 32.2271 226.329 30.5647Z"
          fill={logoColor}
        />
        <path
          d="M246.694 27.6542C249.9 27.6542 250.494 30.3259 250.612 32.879H243.072C243.191 30.5634 243.844 27.6542 246.694 27.6542ZM247.109 42.5567C243.725 42.5567 243.072 39.6475 243.072 36.7976H257.203C257.203 29.9103 254.769 23.7949 246.813 23.7949C239.925 23.7949 236.482 29.376 236.482 35.6695C236.482 42.2599 240.4 46.416 246.991 46.416C251.503 46.416 256.134 44.516 256.431 39.4693H250.731C250.375 41.488 249.247 42.5567 247.109 42.5567Z"
          fill={logoColor}
        />
      </svg>
    </span>
  );
};

export default SwissreLogo;
